class EventLogger {
    private readonly isDebugEnabled: boolean;

    constructor() {
        this.isDebugEnabled = process.env.NODE_ENV === 'development';
        this.debug('Logger initialized', { environment: process.env.NODE_ENV });
    }

    setUser(user: string) {
        this.debug('Set user', { user });
    }

    log(event: string, properties?: Record<string, any>) {
        this.debug(event, properties);
    }

    private debug(message: string, properties?: Record<string, any>) {
        if (!this.isDebugEnabled) {
            return;
        }

        if (properties) {
            console.debug(`[EventLogger] ${message}`, properties);
            return;
        }

        console.debug(`[EventLogger] ${message}`);
    }
}

const logger = new EventLogger();
export { logger };